<template>
  <b-tag :type="presenter.class" :size="size">{{ presenter.label }}</b-tag>
</template>

<script>
export default {
  computed: {
    presenter () {
      const presenter = {}
      if (this.seat.paused_at) {
        presenter.class = 'is-warning is-light'
        presenter.label = 'Paused'
      } else if (this.seat.started_at) {
        presenter.class = 'is-success is-light'
        presenter.label = 'Active'
      } else if (this.seat.approved_at) {
        presenter.class = 'is-info is-light'
        presenter.label = 'Approved'
      } else if (this.seat.completed_at) {
        presenter.class = 'is-grey is-light'
        presenter.label = 'Completed'
      } else {
        presenter.class = 'is-grey is-light'
        presenter.label = 'Pending'
      }
      return presenter
    }
  },
  props: {
    seat: {
      type: Object,
      required: true
    },
    size: {
      type: [String, null],
      default: 'is-small'
    }
  }
}
</script>
